import { render, staticRenderFns } from "./LocalResources.vue?vue&type=template&id=d9c9c8d8"
import script from "./LocalResources.vue?vue&type=script&lang=ts"
export * from "./LocalResources.vue?vue&type=script&lang=ts"
import style0 from "./LocalResources.vue?vue&type=style&index=0&id=d9c9c8d8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports